import DistributionByDateWidget from './DistributionByDateWidget';
export default DistributionByDateWidget;



// WEBPACK FOOTER //
// ./src/components/widgetTypes/components/DistributionByDateWidget/index.js